import type { CardAppearance } from '@atlaskit/linking-common/types';

import { fg } from '@confluence/feature-gating';
import { ConfluenceEditorCardProvider } from '@confluence/smartlinks';

const isLoomUrl = (url: string) => {
	return url.match(
		// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
		/^https:\/\/(.*?\.)?(loom\..*?\/(share|embed))\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})/,
	);
};

// MAUI app URLs: whiteboards and diagram apps embedded via native embeds
const isWhiteboardUrl = (url: string): boolean =>
	// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
	!!url.match(/\/wiki\/spaces\/?.*\/whiteboard\/(?<resourceId>\d+)(\?\/)?/) ||
	!!url.match(
		// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
		/\/wiki\/spaces\/?.*\/whiteboard\/(?<resourceId>[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})(\?\/)?/,
	);

const isMauiUrl = (url: string): boolean => /\/remix\/ui\/[A-Za-z0-9_-]+/.test(url);

export class InlineCommentEditorCardProvider extends ConfluenceEditorCardProvider {
	protected getHardCodedAppearance(url: string): CardAppearance | undefined {
		if (isLoomUrl(url)) {
			return 'embed';
		}
		if (fg('cc_maui_embed_in_comment_editor')) {
			if (isWhiteboardUrl(url) || isMauiUrl(url)) {
				return 'block';
			}
		}
	}
}
